module.exports = __webpack_public_path__ + "img/JC.1595a3ea.png";